var React = require('react');

function GlassdoorIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Glassdoor logo"),React.createElement("description",{"key":1},"Find SendGrid on Glassdoor"),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M7.181 0c.991 0 1.795.767 1.795 1.714h-7.18v7.04c0 .034-.03.062-.066.062H.065A.064.064 0 0 1 0 8.753V1.714C0 .767.804 0 1.795 0h5.386zm0 10.285H0c0 .455.189.891.526 1.213.336.321.793.502 1.27.502H7.18c.991 0 1.795-.767 1.795-1.714v-7.04a.064.064 0 0 0-.065-.063H7.246a.064.064 0 0 0-.065.063v7.04z","fill":"#546B81"}))]);
}

GlassdoorIcon.defaultProps = {"width":"9","height":"12","viewBox":"0 0 9 12"};

module.exports = GlassdoorIcon;

GlassdoorIcon.default = GlassdoorIcon;
